import { useContext, useState } from "react";
import VerticalTab from "./VerticalTab";
import QuoteText from "../Text/QuoteText";
import { LangContext } from "../../App";
import SaudiGreenInitiative from '../../assets/images/tabs/Saudi_green_initiative_image.png'

const tabContents = [
  [
    <h4 className='title'>What is Murooj, and can you
      tell us more about it?</h4>,
    <p className="subtitle">
      Our organisation, Murooj
      Foundation, is closely aligned
      with Vision 2030, which states
      that the Kingdom shall achieve
      carbon neutrality by 2060. This
      ambitious goal requires collective
      efforts from both the private and
      public sectors. Reforestation
      plays a crucial role in enhancing the carbon capture capacity
of the land, making us pivotal
contributors to this national
initiative..
    </p>,
    <h4 className='title'>What is the impact of the
    project?</h4>,
    <p className="subtitle">
      SAB’s commitment to planting
1 million trees is a fantasticcontribution to both our
foundation’s and national goals.
From 2023 through 2024, SAB’s
support will enable us to plant
900,000 mangrove trees. The
specific variety of mangroves -
Avicennia marina- is known for its
carbon sequestration potential,
capturing up to 1.5 metric tons
of CO2
 per tree over its 60-year
lifetime. Beyond carbon capture,
this initiative brings numerous
eco-system benefits. We aim
to restore the Red Sea Coast,
addressing environmental
degradation caused by various
anthropogenic activities. This
mangrove restoration project
helps protect the coastal
ecosystem, improves the water
quality, acts as a carbon sink, and
increases biodiversity (e.g., fish,
shrimp, migratory birds), thereby
also positively impacting local
economies.
    </p>,
    <h4 className='title'>How do you ensure the longterm sustainability of the
    project? 
    </h4>,
    <p className="subtitle">
      The impact of the 900,000 planted
trees is significant, but a key
consideration for us is ensuring
the permanence of these trees.
The entire project is implemented
on governmental lands, where the
NCVC takes responsibility for its sustainability and protection. SAB
is responsible for nurturing the
saplings until 2027, ensuring their
strength and health. Additionally,
to minimise transportation-related
damage, the saplings are grown
in plant nurseries near where they
will ultimately be planted.
    </p>,
    <h4 className='title'>How did you experience the
    collaboration with SAB? 
    </h4>,
    <p className="subtitle">
      SAB was among the first
companies to join this initiative,
showcasing a pioneering spirit.
We observed that SAB was
already actively engaged in
climate change and sustainability
topics, so they were a natural
partner for us. Since then,
collaboration has been mutually
beneficial, allowing us to do
our work and enabling SAB to
amplify its positive environmental
impact. SAB also helped us gain
momentum and become more
visible to a broader spectrum of
organisations, which is an added
benefit of our work with SAB.
    </p>,
    <QuoteText text="“This agreement falls within the framework of the Foundation's efforts to
    strengthen collaboration with various institutions in the public and
    private sectors in order to achieve the goals of SGI, particularly given
    the strong community interaction and desire to participate in this
    national initiative. We are happy to offer all forms of aid and support
    for any activities targeted at increasing vegetation cover and improving
    environmental efforts in accordance with the Kingdom's Vision 2030. We
    would like to thank the Saudi British Bank for introducing this program,
    which will directly benefit environmental protection and quality of life.”
     "
    />,
    // <div className="space-25"></div>,
    // <p className="red-text"><b>Eng. Wael Bousheh</b></p>,
    // <p className="subtitle">CEO of the Vegetation Development Corporation "Morooj"</p>
  ],
  [
    <h4 className='title'>Native Plant Conservation and Propagation Centre</h4>,
    <p className="subtitle">
      As part of the SGI’s afforestation drive, the Kingdom’s native wild plants
      receive special attention as a vital component of eco-tourism and valuable
      genetic resources. However, many of these native species face extinction.
      The Environmental Awareness Association partnered with SAB to establish a
      centre for the conservation and propagation of local plants – a first of
      its kind in the Kingdom. More than one million square metres of land has
      been allocated for the centre in Al-Asiaf National Park in Qassim region.
    </p>,
    <h4 className='title'>Approach</h4>,
    <p className="subtitle">
      The goal of SAB and The Environmental Awareness Association is to
      introduce plant diversity in the Kingdom and promote the preservation of
      this national treasure.<br /><br /> The roadmap to achieving these objectives include
      various activities, such as planting 10,000 local trees at the project
      site and establishing nurseries, plant incubators and growing rooms.
      Additionally, both organisations will make a concerted effort to provide a
      suitable research environment for researchers and graduate students in the
      fields of afforestation and desertification, supported by workshops and
      training programs. Viable seeds and vigorous seedlings of native plants
      will be provided to researchers, amateurs, and relevant authorities for
      scientific research and to save endangered native plant species from
      extinction.
    </p>,
    <h4 className='title'>Outcomes</h4>,
    <p>The project will contribute to SGI through:</p>,
    <ul className="normal-list">
      <li>Planting 10,000 trees in the site.</li>
      <li>Producing 200,000 seedlings per year</li>
      <li>Providing viable seeds of native plants by reducing seed germination failure from 70% to 5%.</li>
      <li>Conducting workshops and training with more than 10,000 participants annually to raise environmental awareness.</li>
      <li>Saving 10 endangered plant species per year through collection, propagation and distribution.</li>
      <li>Conducting 8 scientific research projects related to SGI</li>
      <li>Providing seeds and seedlings of native plant to researchers, and relevant authorities.</li>
      <li>Highlighting the plant diversity in the Kingdom.</li>
    </ul>,
    <p className="subtitle">
    </p>,
    <QuoteText text={`“ The implementation of this outstanding project with the support of SAB
    will be a qualitative leap in social responsibility and a model for
    cooperation between the government, private and non-profit sectors for a
    healthy and sustainable environment.”`} />,
    <div className="space-25"></div>,
    <p className="red-text"><b>Dr. Abdulrahman A. Al-Soqeer</b></p>,
    <p className="subtitle">Chairman of Board of Directors for Environmental Awareness Association</p>
  ],
];

const tabsContentsAr = [
  [
    <h4 className='title'>تحسين الأصول الطبيعية للمملكة</h4>,
    <p className="subtitle">
      تهدف مبادرة السعودية الخضراء إلى بناء مستقبل أكثر خضرة واستدامة للمملكة العربية السعودية. وتتضمن برامجها زراعة 10 مليارات شجرة في مختلف مناطق المملكة. وستساهم هذه المبادرة في استعادة الوظائف البيئية الحيوية، وتحسين جودة الهواء، والحد من العواصف الغبارية والرملية، وغير ذلك.
    </p>,
    <h4 className='title'>النهج</h4>,
    <p className="subtitle">
      عقد بنك الأول شراكة مع مبادرة السعودية الخضراء من خلال المركز الوطني لتنمية الغطاء النباتي ومكافحة التصحر لزراعة مليون شجرة خلال السنوات الـ 5 القادمة، وتأتي هذه الخطوة ضمن استراتيجية الحوكمة البيئية والاجتماعية والمؤسسية تشغل مهمة إعادة تأهيل غابات أشجار المانغروف على طول سواحل البحر الأحمر والخليج العربي حيزاً كبيراً من هذه الشراكة، حيث تعتبر هذه الغابات جزءاً لا يتجزأ من النظام البيئي الساحلي للمملكة. كما تمتلك هذه الأشجار أهمية خاصة في مكافحة تغير المناخ، نظراً لكميات الكربون الكبيرة التي تخزنها هذه الأشجار تحتها. سيسهم هذا النوع من أشجار المانغروف أيضاً في تعزيز التنوع البيولوجي، حيث يتمثل دورها في كونها موطناً للشعاب المرجانية والكائنات البحرية اللافقارية والفقارية، بما في ذلك السلاحف والطيور، بالإضافة إلى أنواع أخرى من الحيوانات والنباتات.
    </p>,
    <h4 className='title'>النتائج</h4>,
    <p className="subtitle">
      تساعد كل شجرة جديدة تزرع في المملكة، وخاصة شتلات أشجار المانغروف، على إزالة الكربون من الغلاف الجوي. وتساهم هذه المبادرة في تحقيق أهداف بنك الأول في الحد من الانبعاثات الكربونية، وإتاحة فرصة حقيقية أمام موظفي البنك للمشاركة في زراعة الأشجار كنشاط جماعي، كما تشجع البنوك والشركات الأخرى على المشاركة في جهود مكافحة تغير المناخ. كما تعمل مستنقعات المانغروف كبيئة حاضنة لليرقات، وملاذاً لمجموعة متنوعة من الأسماك في مرحلة النمو التي تعتبر ذات أهمية تجارية، بما في ذلك الروبيان. بالإضافة إلى ذلك، يمكن لهذه المستنقعات أن تؤثر بشكل إيجابي على المجتمع من خلال تحسين سبل العيش للمجتمعات المحلية التي تعتمد على الصيد.
    </p>,
    <QuoteText text="“تندرج هذه الاتفاقية في إطار جهود البنك الرامية إلى تعزيز التعاون مع مختلف المؤسسات في القطاعين العام والخاص من أجل تحقيق أهداف مبادرة السعودية الخضراء، وخصوصاً بالنظر إلى التفاعل القوي من المجتمع والرغبة في المشاركة في هذه المبادرة الوطنية. ويسعدنا أن نقدم جميع أشكال المساعدة والدعم اللازمين لأي أنشطة تستهدف زيادة الغطاء النباتي وتحسين الجهود البيئية وفقا لمستهدفات رؤية المملكة 2030. ونود أن نتوجه بجزيل الشكر إلى البنك على تقديم هذا البرنامج، الذي سيعود بالفائدة المباشرة على حماية البيئة وجودة الحياة.”"
    />,
    <div className="space-25"></div>,
    <p className="red-text"><b>المهندس. وائل بوشه</b></p>,
    <p className="subtitle">الرئيس التنفيذي لمؤسسة تنمية الغطاء النباتي "مروج"</p>
  ],
  [
    <h4 className='title'>مركز حفظ النباتات المحلية وإكثارها</h4>,
    <p className="subtitle">
      ضمن حملة التشجير التي أطلقتها مبادرة السعودية الخضراء، تحظى النباتات البرية المحلية في المملكة باهتمام خاص بصفتها عنصراً حيوياً للسياحة البيئية، إضافةً إلى كونها مصدراً ثميناً للتنوع الوراثي. ومع ذلك، تواجه العديد من هذه الأنواع المحلية خطر الانقراض. عقدت جمعية وعي البيئية شراكة مع بنك الأول لإنشاء مركز حفظ النباتات المحلية وإكثارها، والذي يُعد الأول من نوعه في المملكة. تم تخصيص أكثر من مليون متر مربع من الأراضي للمركز في منتزه الأسياف الوطني في منطقة القصيم.
    </p>,
    <h4 className='title'>النهج</h4>,
    <p className="subtitle">
      تهدف الاتفاقية بين بنك الأول وجمعية وعي البيئية إلى تعزيز التنوع النباتي في المملكة والحفاظ على هذا الكنز الوطني.<br /><br />
      وتشمل خطة تحقيق هذين الهدفين مجموعة من الأنشطة المتنوعة، مثل زراعة 10,000 شجرة محلية في موقع المشروع، وإنشاء مشاتل وحاضنات نباتات. بالإضافة إلى ذلك، سيبذل الطرفان جهوداً مشتركة لتوفير بيئة بحثية مناسبة للباحثين والطلاب في مجالات التشجير والتصحر، مدعومة بورش العمل والبرامج التدريبية. سيتم توفير بذور قابلة للنمو وشتلات القوية للنباتات المحلية للباحثين ومحبي الطبيعة والهيئات ذات الصلة لأهداف البحث العلمي والمساعدة في الحفاظ على الأنواع المحلية المهددة بالانقراض.
    </p>,
    <h4 className='title'>النتائج</h4>,
    <p>سيساهم المشروع في مبادرة السعودية الخضراء من خلال:</p>,
    <ul className="normal-list">
      <li>زراعة 10,000 شجرة في الموقع</li>
      <li>إنتاج 200,000 شتلة سنوياً</li>
      <li>توفير بذور قابلة للنمو من النباتات المحلية من خلال تقليل نسبة فشل إنبات البذور من 70% إلى 5%</li>
      <li>عقد ورش عمل وتدريب مع أكثر من 10000 مشارك سنوياً لزيادة الوعي البيئي</li>
      <li>إنقاذ 10 أنواع نباتية مهددة بالانقراض سنوياً من خلال جمعها وتوزيعها وتوفير البيئة المناسبة لإكثارها</li>
      <li>إجراء 8 مشاريع بحث علمي متعلقة بمبادرة السعودية الخضراء</li>
      <li>توفير بذور وشتلات النباتات المحلية للباحثين والجهات ذات العلاقة</li>
      <li>تسليط الضوء على التنوع النباتي في المملكة</li>
    </ul>,
    <p className="subtitle">
    </p>,
    <QuoteText text={`“أن تنفيذ هذا المشروع المتميز بدعم من الأول، سيكون نقلة نوعية في المسؤولية الاجتماعية للشركات، ونموذجاً للتعاون بين القطاعات الحكومية والخاصة وغير الربحية من أجل بيئة مستدامة.”`} />,
    <div className="space-25"></div>,
    <p className="red-text"><b>د. عبدالرحمن بن عبدالله الصقير</b></p>,
    <p className="subtitle">رئيس مجلس إدارة جمعية التوعية البيئية</p>
  ],
]

export default function VerticalTabs({
  title = "",
  tablist = [],
  tabContent = tabContents,
}: {
  title: string,
  tablist: string[],
  tabContent?: JSX.Element[][],
}) {
  const { lang } = useContext(LangContext);

  const [activeTab, setActiveTab] = useState(0);

  const tabData = lang ? tabsContentsAr : tabContents

  const handleClick = (index: number) => setActiveTab(index);
  return (
    <div className="vertical-tabs">
      <div className="vertical-tabs__header">
        <h3 className="vertical-tabs__header-title">{title}</h3>
        {tablist.map((tab, index) => (
          <div key={index} className={"vertical-tab__top-border"}>
            <VerticalTab
              onClick={() => handleClick(index)}
              label={tab}
              isActive={index === activeTab}
              style={{}}
            />
          </div>
        ))}
      </div>
      <div className="vertical-tabs__content-container">
        {tabData.map((content, index) =>
          activeTab === index ? (
            <div
              key={activeTab}
              className="vertical-tabs__content-container-tab"
            >
              {content}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
}
